import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jiraBugsSearchPipe'
})
export class JiraBugsSearchPipePipe implements PipeTransform {

  transform(items: any[], text: String, type: String, levels: any[]): any {
    return items.filter((item) => {
    if(type == 'bug'){
      if(item.summary.toLocaleLowerCase().includes(text.toLocaleLowerCase()) && this.filterLevel(item, levels) == true){
      return item;
    }
    }
        
    if(type == 'filter'){
      return item.name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    }
      
    });
  }

  filterLevel(item: any, levels: any) {
    // console.log(levels);
    if (levels.length > 0) {
      if (levels.indexOf(item.level) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
}
